import React from 'react';
import { avatarSizePropTypes, AVATAR_MEDIUM } from './avatarSizes';

import '@static/css/candidate/phil/_phil_avatar.less';

/**
 * JS-7203 personal recruiter
 */
export const PhilAvatar = ({ size }) => (
  <div
    className={`phil_avatar ${size || ''}`}
  />
);
PhilAvatar.propTypes = {
  size: avatarSizePropTypes,
};
PhilAvatar.defaultProps = {
  size: AVATAR_MEDIUM,
};

export default PhilAvatar;
